/**
 * Created by MRQ on 2016/1/21.
 */
'use strict';
angular.module('websiteLinkDocModule', []).controller('editingCenterWebsiteLinkDocCtrl', websiteLinkDoc);
websiteLinkDoc.$injector = [
    '$scope',
    'beforeonload',
    '$rootScope',
    '$compile',
    '$element',
    '$filter',
    '$q',
    '$state',
    '$modal',
    '$timeout',
    '$location',
    '$validation',
    '$window',
    'jsonArrayToStringService',
    'initeditctrBtnsService',
    'initVersionService',
    'initAddMetaDataService',
    '$anchorScroll',
    'trsHttpService',
    'initSingleSelecet',
    'modalDialog',
    'trsspliceString',
    'editingCenterService',
    '$sce',
    'initWebsiteDataService',
    'websiteService',
    'filterEditctrBtnsService',
    'initWebsiteNewsService',
    'trsSelectDocumentService',
    'Upload',
    'websiteBtnService',
    'editIsLock',
    'storageListenerService',
    'localStorageService',
    'sensitiveWordCheckService',
    'editcenterRightsService',
    'heimaCheckService',
    'iWoService',
    'newMediaService',
    'websiteConst',
    'messagePublishService',
];
var editCallback = null;
var editPhotoCallback = null;

/**
 * 链接稿件
 */
function websiteLinkDoc(
    $scope,
    beforeonload,
    $rootScope,
    $compile,
    $element,
    $filter,
    $q,
    $state,
    $modal,
    $timeout,
    $location,
    $validation,
    $window,
    jsonArrayToStringService,
    initeditctrBtnsService,
    initVersionService,
    initAddMetaDataService,
    $anchorScroll,
    trsHttpService,
    initSingleSelecet,
    modalDialog,
    trsspliceString,
    editingCenterService,
    $sce,
    initWebsiteDataService,
    websiteService,
    filterEditctrBtnsService,
    initWebsiteNewsService,
    trsSelectDocumentService,
    Upload,
    websiteBtnService,
    editIsLock,
    storageListenerService,
    localStorageService,
    sensitiveWordCheckService,
    editcenterRightsService,
    heimaCheckService,
    iWoService,
    newMediaService,
    websiteConst,
    messagePublishService
) {
    initStatus();
    initData();
    websiteService.addFuture($scope, ['sendmessage']);

    /**
     * [initStatus description]初始化状态
     *
     * @return  {[type]}  [return description]
     */
    function initStatus() {
        $scope.page = {
            CURRPAGE: 1,
            PAGESIZE: 20,
        };
        $scope.returnParams = {}; // 链接稿返回的参数
        $anchorScroll.yOffset = 55;
        $scope.status = {
            newsFormError: [],
            websiteAscription: $state.params.wzmetadataid === undefined ? 'false' : 'true', // 判断是否是新建 新建情况下才女战士归属人
            switch: 'manuscriptInfo', // 默认选中稿件信息
            chnldocid: $state.params.wzchnldocid,
            openBtn: true,
            files: [], // 上传附件绑定数组
            showFiles: [], // 附件展示以及上传字段
            isUploaderFile: false, // 上传按钮是否可点击
            isSubTitleShow: true,
            hasVersionTime: false,
            isEditDraft: !!angular.isDefined($state.params.wzchnldocid), // 是否是编辑稿件说
            position: $state.params.wzplatform,
            isCheckSensitiveWords: false,
            sensitiveWordTit: '敏感词校验',
            heimaCheckTit: '错别字校对',
            isFusionEditor: $state.current.name == 'fusionlinkdoc', // 是否来自融合编辑器
            isawaitrevise: $state.params.isawaitrevise,
            pictureSize: '',
            picRatio: 0
        };
        $scope.data = {
            userName: '',
            srcUrl: '', // 由稿件链接生成的稿件页面
            KEYWORDS: [],
            selectTagArray: [],
            specialDoc: 0,
            channelParams: {
                serviceid: 'mlf_mediasite',
                methodname: 'getChannelPath',
                ChannelId: $state.params.wzchannelid,
                Burster: '>',
            },
            trench: websiteConst.listenStroageKey,
            copyVersion: [],
            tag: {
                hasChoose: false,
                originalTag: [],
                selectTag: [],
            },
            ownerSelectedItems: '',
            comment: {
                comment: [],
                voiceObj: {},
                hasMore: false,
                currPage: 1,
            },
            moveMethodName: {
                0: 'moveDAIBIANDoc',
                1: 'moveDAISHENDoc',
                2: 'moveYIQIANFADoc',
            },
        };
        if ($scope.status.isFusionEditor) {
            $scope.params = {
                serviceid: 'mlf_fusioncreate',
                methodname: 'getWebFusionDoc',
                sourceDocId: $scope.data.sourceDocId || $state.params.iwometadataid,
            };
        } else {
            $scope.params = {
                siteId: $state.params.wzsiteid,
                ChannelId: $state.params.wzchannelid,
                serviceid: 'mlf_website',
                methodname: 'getLinkDoc',
                METADATAID: $state.params.wzmetadataid,
            };
            initBtnArray();
        }
        emitCloseWindow();
        $scope.editFlag = {
            media: 'website',
            docType: 'linkdoc',
        };
    }

    /**
     * [theFormError description] 获取表单变化
     * @return {[type]} [description]
     */
    $scope.theFormError = function () {
        // 当表单发生变化时会进入方法
        var errorArray = [];
        for (var error in $scope.linkDocForm.$error) {
            errorArray.push(error);
        }
        $scope.status.newsFormError = $scope.status.newsFormError == undefined ? [] : $scope.status.newsFormError;
        if ($scope.status.newsFormError.length != errorArray.length) {
            // 长度不相等说明表单errorname发生变化
            $scope.status.newsFormError = errorArray;
        }
        return $scope.status.newsFormError; // 返回
    };

    /**
     * [emitCloseWindow description]标签页关闭页面时，发送稿件解锁信息给其他页面，协助解锁该稿件
     * @return {[type]} [description]
     */
    function emitCloseWindow() {
        window.onbeforeunload = function () {
            localStorageService.set(
                'unLocakDraft',
                JSON.stringify({
                    metadataid: $state.params.wzmetadataid,
                })
            );
        };
    }

    /**
     * [initData description]初始化数据
     *
     * @return  {[type]}  [return description]
     */
    function initData() {
        $scope.handleBtnClick = function (funname) {
            eval('$scope.' + funname + '()');
        };
        // 判断是否有修订完成权限
        if ($scope.status.isawaitrevise) {
            editcenterRightsService.initIwoListBtn('iwo.xiuding').then(function (rights) {
                $scope.status.btnRights = rights;
            });
        }
        if (!$scope.status.isFusionEditor) {
            (angular.isDefined($state.params.wzchnldocid) ? initEditDraftData() : initNewDraftData()).then(function () {
                beforeonload.beforeonloadAlert($scope); // 关闭窗口监听，检查页面是否修改，让用户确认是否保存
            });
        }
        // 融合编辑器下获取评审意见
        if ($state.params.iwometadataid) {
            getComment($state.params.iwometadataid, $scope.data.comment.currPage);
        }
        // 非融合编辑器的裁剪功能
        getCutPictureWidthHeight();
    }

    /**
     * [loadDirective description]动态加载指令
     *
     * @return  {[type]}  [return description]
     */
    function loadDirective() {
        editingCenterService.loadManuscriptType($scope, $element); // 加载稿件原创部分
        if (!$scope.status.isFusionEditor) {
            var draftList =
                '<editor-dir list="list" meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="linkDocForm"></editor-dir>' +
                '<editor-auth-dir author="list.FGD_AUTHINFO"></editor-auth-dir>';
            draftList = $compile(draftList)($scope);
            $element.find('editor').append(draftList);
        }
    }

    /**
     * [getCutPictureWidthHeight description]获取图片编辑默认宽高
     * @return {[type]} [description]
     */
    function getCutPictureWidthHeight() {
        editingCenterService.querySettedPicSize('website').then(function (data) {
            $scope.status.pictureSize = websiteService.resetPicSize(data.OutLinePicSize);
        });
    }

    /**
     * [initNewDraftData description]初始化新建页面
     * @param {[type]} [dealWithListFun] [description] 融合编辑器下处理list的方法
     * @return {[type]} [description]
     */
    function initNewDraftData(dealWithListFun) {
        var deffer = $q.defer();
        $scope.list = initWebsiteDataService.initLinkDoc();
        $scope.list.CHANNELID = $state.params.wzchannelid;
        initKeyWords();
        getChannel();
        initDocgenre().then(() => {
            // 融合编辑器下处理list
            if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                dealWithListFun();
            }
        });
        loadDirective();
        deffer.resolve();
        return deffer.promise;
    }


    /**
     * [initDocgenre description]初始化稿件体裁
     * @param   {[type]}  obj  [obj description]
     * @return  {[type]}       [return description]
     */
    function initDocgenre(obj) {
        let defer = $q.defer();
        iWoService.initData().then(function (data) {
            $scope.docgenre = data.DocGenre;
            $scope.list.DOCGENRE = angular.isDefined(obj) ? obj.DOCGENRE : angular.copy($scope.docgenre[0]);
            defer.resolve();
        });
        return defer.promise;
    }

    /**
     * [initEditDraftData description]初始化编辑页面
     * @param {[type]} [dealWithListFun] [description] 融合编辑器下处理list的方法
     * @return {[type]} [description]
     */
    function initEditDraftData(dealWithListFun) {
        var defer = $q.defer();
        trsHttpService.httpServer('/wcm/mlfcenter.do', $scope.params, 'get').then(function (data) {
            $scope.list = data;
            $scope.data.SPECIALDOC = $scope.list.SPECIALDOC;
            $scope.list.serviceid = 'mlf_website';
            $scope.list.methodname = 'saveLinkDoc';
            initKeyWords();
            reWriteAttachFile(data);
            document.title = $scope.list.TITLE = $scope.list.TITLE.split('<br />').join('\n');
            // $scope.list.OUTLINEPICS = doWithPicsOrAttach($scope.list.OUTLINEPICS);
            getChannel();
            // 稿件加锁
            editIsLock.lockDraft($state.params.wzmetadataid);
            // 请求这个稿件的标签
            getCurrDraftTag();
            // 获取评审意见
            if (!$state.params.iwometadataid) {
                getComment($state.params.wzmetadataid, $scope.data.comment.currPage);
            }
            initDocgenre(data);
            resolveOUTLINEPIC(); // 编辑稿件时添加加号
            // 如果稿件返回了发稿单信息，则展示发稿单
            if ($scope.status.isFusionEditor) {
                // 融合编辑器下处理list
                if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                    dealWithListFun();
                }
                // 获取流程版本与操作日志
                getVersion().then(function () {
                    defer.resolve();
                });
            } else if (data.FUSION == 'true') {
                loadDirective();
                getVersion();
                $timeout(function () {
                    var fgdHeight = $('.website_manuscript_partthree').height();
                    var fgdWidth = $('.website_manuscript_partthree').width();
                    $('.fgdCantEdit')
                        .find('.cantEditPart')
                        .height(fgdHeight)
                        .width(fgdWidth);
                    $('.website_manuscript_partthree').resize(function () {
                        $('.fgdCantEdit')
                            .find('.cantEditPart')
                            .height($(this).height());
                    });
                });
                defer.resolve();
            } else {
                getVersion();
                loadDirective();
                defer.resolve();
            }
        });
        return defer.promise;
    }

    /**
     * [getChannel description]根据栏目ID获取栏目名称
     *
     * @return  {[type]}  [return description]
     */
    function getChannel() {
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.data.channelParams, 'get').then(function (data) {
            $scope.CHANNEL = data.replace(/\"/g, '');
        });
    }

    /**
     * [subTitleShow description]点击显示隐藏副标题
     *
     * @return  {[type]}  [return description]
     */
    $scope.subTitleShow = function () {
        $scope.status.isSubTitleShow = !$scope.status.isSubTitleShow;
    };

    /**
     * [resolveOUTLINEPIC description]编辑稿件时添加加号
     *
     * @return  {[type]}  [return description]
     */
    function resolveOUTLINEPIC() {
        if (!$scope.list.OUTLINEPICS) {
            $scope.list.OUTLINEPICS = [];
        }
        $scope.list.OUTLINEPICS.push({
            APPFILE: '',
            APPDESC: '',
            PERPICURL: '',
        });
    }

    /**
     * [goto description]锚点切换开始
     *
     * @param   {[type]}  id  [id description]
     *
     * @return  {[type]}      [return description]
     */
    $scope.goto = function (id) {
        $location.hash(id);
        $anchorScroll();
    };

    /**
     * [chooseChannel description]选择栏目
     *
     * @return  {[type]}  [return description]
     */
    $scope.chooseChannel = function () {
        if ($scope.status.position == 2) {
            return;
        }
        websiteService.singleChooseChnl('栏目选择', $state.params.wzsiteid, $scope.list.CHANNELID, '', 1, function(data_1) {
            $scope.getChannelParams = {
                serviceid: 'mlf_mediasite',
                methodname: 'getChannelPathAndId',
                ChannelId: data_1.channelid,
                Burster: '>',
            };
            $scope.loadingPromise = trsHttpService.httpServer('/wcm/mlfcenter.do', $scope.getChannelParams, 'get').then(
                function (data_2) {
                    moveDarft(data_2);
                    // template($scope.list.CHANNELID);
                },
                function (data) { }
            );
        });
    };

    /**
     * [getVersion description]获取流程版本与操作日志
     *
     * @param   {[type]}  id  [id description]
     *
     * @return  {[type]}      [return description]
     */
    function getVersion(id) {
        var defer = $q.defer();
        var metadataid = angular.isDefined(id) ? id : $state.params.wzmetadataid;
        metadataid = $state.params.iwometadataid ? $state.params.iwometadataid : metadataid;
        editingCenterService.getEditVersionTime(metadataid, $scope.page, $scope.data.copyVersion).then(function (data) {
            $scope.data.version = data;
            $scope.page = data.page;
            $scope.data.copyVersion = data.copyArray;
            $scope.status.hasVersionTime = true;
            defer.resolve();
        });
        return defer.promise;
    }

    /**
     * [isShowVersion description] 没有操作日志或流程版本时不显示图标和'没有更多'
     * @param  {[type]}  key [description] 操作日志或流程版本的数据
     * @return {Boolean}     [description]
     */
    $scope.isShowVersion = function (key) {
        if (key === undefined) {
            return false;
        } else {
            for (var i in key) {
                return true;
            }
            return false;
        }
    };

    /**
     * [getLoadMore description]操作日志加载更多
     * @return {[type]} [description]
     */
    $scope.getLoadMore = function () {
        $scope.page.CURRPAGE++;
        getVersion();
    };

    /**
     * [getComment description] 获取评审意见
     * @param   {[type]}  id        [id description]
     * @param   {[type]}  currPage  [currPage description]
     * @return  {[type]}            [return description]
     */
    function getComment(id, currPage) {
        editingCenterService.getComment(id, currPage).then(function (data) {
            if (
                angular.isDefined($scope.data.comment.comment[$scope.data.comment.comment.length - 1]) &&
                $filter('date')($scope.data.comment.comment[$scope.data.comment.comment.length - 1].day, 'yyyy-MM-dd').toString() ==
                $filter('date')(data.comment[0].day, 'yyyy-MM-dd').toString()
            ) {
                $scope.data.comment.comment[$scope.data.comment.comment.length - 1].times = $scope.data.comment.comment[
                    $scope.data.comment.comment.length - 1
                ].times.concat(data.comment[0].times);
                data.comment.shift();
            }
            $scope.data.comment['comment'] = $scope.data.comment['comment'].concat(data.comment);
            $scope.data.comment.hasMore = data.hasMore;
            for (var i in data.voiceObj) {
                $scope.data.comment.voiceObj[i] = data.voiceObj[i];
            }
        });
    }

    /**
     * [getComment description]获取评审意见
     * @return {[type]} [description]
     */
    $scope.getLoadMoreComment = function () {
        $scope.data.comment.currPage += 1;
        getComment($state.params.wzmetadataid, $scope.data.comment.currPage);
    };

    /**
     * [trustUrl description]信任url
     */
    $scope.trustUrl = $sce.trustAsResourceUrl;

    /**
     * [addUploaderImg description]导读，概览图片上传
     *
     * @param   {[type]}  array  [array description]
     * @param   {[type]}  type   [type description]
     *
     * @return  {[type]}         [return description]
     */
    $scope.addUploaderImg = function (array, type) {
        if (array.length > 9) {
            modalDialog.alertType(type + '最多支持10张', '', 'error', 'confirm');
            return;
        }
        array.push({
            APPFILE: '',
            APPDESC: '',
            PERPICURL: '',
        });
    };

    /**
     * [uploadImg description]导读，概览图片上传
     *
     * @return  {[type]}  [return description]
     */
    $scope.uploadImg = function () {
        if ($scope.list.OUTLINEPICS.length == 10) {
            // 导读图片最多允许上传10张
            return;
        }
        if ($scope.list.OUTLINEPICS[$scope.list.OUTLINEPICS.length - 1].relationId) {
            $scope.list.OUTLINEPICS.push({
                APPFILE: '',
                APPDESC: '',
                PERPICURL: '',
            });
        }
    };

    /**
     * [deleteImgContainer description]删除图片容器
     * @param  {[obj]} item  [description]要删除的某项
     * @param  {[obj]} array [description]要删除的图片数组
     * @return {[type]}       [description]null
     */
    $scope.deleteImgContainer = function (item, array) {
        array.splice(array.indexOf(item), 1);
    };

    /**
     * [updateCKSelection description]trsCheckBox的回调函数
     * @param  {[str]} attribute [description]需要改变的属性
     * @return {[type]}           [description]
     */
    $scope.updateCKSelection = function (attribute) {
        $scope.list[attribute] = $scope.list[attribute] == '0' ? '1' : '0';
    };

    /**
     * [save description]点击保存
     *
     * @return  {[type]}  [return description]
     */
    $scope.save = function () {
        var defer = $q.defer();
        save(true).then(
            function (data) {
                if ($scope.$root.cureditpage === undefined || $scope.$root.cureditpage === 'websitelinkdoc') {
                    editIsLock.lockDraft($state.params.wzmetadataid);
                    getVersion($scope.list.METADATAID);
                    var params;
                    if ($scope.status.isFusionEditor) {
                        params = {
                            serviceid: 'mlf_fusioncreate',
                            methodname: 'getWebFusionDoc',
                            sourceDocId: $scope.data.sourceDocId || $state.params.iwometadataid,
                        };
                    } else {
                        params = {
                            siteId: $state.params.wzsiteid,
                            ChannelId: $state.params.wzchannelid,
                            serviceid: 'mlf_website',
                            methodname: 'getLinkDoc',
                            METADATAID: $state.params.wzmetadataid,
                        };
                    }
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                        function (data) {
                            reWriteAttachFile(data);
                            defer.resolve();
                        },
                        function () {
                            defer.resolve();
                        }
                    );
                } else {
                    defer.resolve();
                }
            },
            function () {
                defer.reject();
            }
        );
        return defer.promise;
    };

    /**
     * [webCompileSend description]保存并送审
     *
     * @return  {[type]}  [return description]
     */
    $scope.webCompileSend = function () {
        saveSend();
    };

    /**
     * [webCompileSignDirect description]待编平台直接签发
     * @return  {[type]}  [return description]
     */
    $scope.webCompileSignDirect = function () {
        let params = {
            serviceid: 'mlf_websiteoper',
            methodname: 'webDaiBianPublish'
        };
        singDirect(params);
    };

    /**
     * [webCompileSignTiming description]待编平台定时签发
     * @return  {[type]}  [return description]
     */
    $scope.webCompileSignTiming = function () {
        var array = [$scope.list];
        sensitiveWordCheckService.SensitiveWordsAndCarefulTiming(array, true).then(
            function () { 
                // 
            },
            function () {
                singTiming();
            }
        );
    };

    /**
     * [webPendingSignDirect description]待审平台直接签发
     *
     * @return  {[type]}  [return description]
     */
    $scope.webPendingSignDirect = function () {
        let params = {
            serviceid: 'mlf_websiteoper',
            methodname: 'webDaiShenPublish'
        };
        singDirect(params);
    };

    /**
     * [webPendingSignTiming description]待审平台定时签发
     *
     * @return  {[type]}  [return description]
     */
    $scope.webPendingSignTiming = function () {
        var array = [$scope.list];
        sensitiveWordCheckService.SensitiveWordsAndCarefulTiming(array, true).then(
            function () {
                // 
            },
            function () {
                singTiming();
            }
        );
    };

    /**
     * [webPendingKill description]待审平台退稿
     *
     * @return  {[type]}  [return description]
     */
    $scope.webPendingKill = function () {
        save().then(function (data) {
            $scope.params.serviceid = 'mlf_websiteoper';
            $scope.params.methodname = 'rejectionMetaDatas';
            rejection();
        });
    };

    /**
     * [preview description]预览
     *
     * @return  {[type]}  [return description]
     */
    $scope.preview = function () {
        // modalDialog.isSecretInformation($state.params.wzmetadataid,function() {
        save().then(function (data) {
            editIsLock.lockDraft($state.params.wzmetadataid);
            preview();
        });
        // }, function() {});
    };

    /**
     * [revise description] 修订
     * @return {[type]} [description]
     */
    $scope.revise = function () {
        modalDialog.confirmModal('修订', '确认修订?', function () {
            save().then(
                function () {
                    var params = {
                        serviceid: 'mlf_modifydoc',
                        methodname: 'paperModifyDocsFinished',
                        PaperDocIds: $state.params.wzmetadataid,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                        function (data) {
                            modalDialog.alertType(
                                '修订成功',
                                '',
                                'success',
                                false,
                                function () {
                                    storageListenerService.addListenerToNewspaper('xiuding');
                                    $window.close();
                                },
                                '',
                                1500
                            );
                        },
                        function (data) {
                            editIsLock.lockDraft($state.params.wzmetadataid);
                        }
                    );
                },
                function () {
                    editIsLock.lockDraft($state.params.wzmetadataid);
                }
            );
        });
    };

    /**
     * [dealDataBeforeSave description]保存前处理数据
     * @return {[type]} [description]
     */
    function dealDataBeforeSave() {
        $scope.status.openBtn = false;
        saveAttachFile();
        examAttachFile();
        getKeyWords();
        // //处理图片问题
        if (angular.isObject($scope.list.CUSTOMTIME)) {
            $scope.list.CUSTOMTIME = $filter('date')($scope.list.CUSTOMTIME, 'yyyy-MM-dd HH:mm').toString();
        }
        var list = angular.copy($scope.list);
        list.OUTLINEPICS = angular.copy(jsonArrayToStringService.clearEmptyObjects(list.OUTLINEPICS, 'APPFILE'));
        // 标题回车处理成</br> 存入数据库里
        list.TITLE = list.TITLE.split('\n').join('<br />');
        list.CONTRIBUTORSAUTHER = $scope.data.userName;
        list.OLDTAGIDS = list.TAGIDS = trsspliceString.spliceString($scope.data.tag.selectTag, 'SPECAILTAGID', ',');
        // 稿件归属人
        list.OWNER = trsspliceString.spliceString($scope.data.ownerSelectedItems, 'USERID', ',');
        list.SPECIALDOC = $scope.data.specialDoc;
        list.ORIGINALTYPE = $scope.data.originType;
        if ($scope.status.isFusionEditor) {
            delete list.ISNOPAYMENT;
            delete list.FGD_EDITINFO;
            delete list.FGD_AUTHINFO;
            delete list.DOCGENRE;
            delete list.NEWSSOURCES;
            list.METADATAID = $state.params.wzmetadataid || '0';
            list.serviceid = 'mlf_fusionwebsite';
            list.methodname = 'saveVirtualLinkDoc';
            list.SourceDocId = $scope.data.sourceDocId || $state.params.iwometadataid;
        } else {
            list.serviceid = 'mlf_website';
            list.methodname = 'saveLinkDoc';
        }
        // JSON对象数组转字符串
        list = jsonArrayToStringService.jsonArrayToString(list);
        return list;
    }

    /**
     * [dealDataAfterSave description]保存以后
     *
     * @param   {[type]}  data  [data description]
     * @param   {[type]}  flag  [flag description]
     *
     * @return  {[type]}        [return description]
     */
    function dealDataAfterSave(data, flag) {
        $scope.status.openBtn = true;
        // 再次初始化标签相关的属性
        $scope.params.MetaDataIds = $state.params.wzmetadataid = $scope.list.METADATAID = data.METADATAID;
        $scope.params.ChnlDocIds = $state.params.wzchnldocid = $scope.list.CHNLDOCID = data.CHNLDOCID;
        $state.params.wzchannelid = angular.isDefined($state.params.wzchannelid) ? $state.params.wzchannelid : $scope.list.CHANNELID;
        initTagAfterSave();
        if (flag) {
            if (!$scope.status.isFusionEditor) {
                storageListenerService.addListenerToWebsite('save');
                $state.transitionTo($state.current, $state.params, {
                    reload: false,
                });
                $timeout(function () {
                    modalDialog.saveModel('保存成功', '', 'success');
                }, 500);
            }
        }
    }

    /**
     * [save description]保存函数
     *
     * @param   {[type]}  flag  [flag description]
     *
     * @return  {[type]}        [return description]
     */
    function save(flag) {
        var deferred = $q.defer();
        $timeout(function () {
            $validation.validate($scope.linkDocForm.authorForm);
            $scope.linkDocForm.$pending = {};
            $validation
                .validate($scope.linkDocForm)
                .success(function () {
                    modalDialog.isSecretInformation(
                        $state.params.wzmetadataid,
                        function () {
                            sensitiveWordCheckService.sensitiveWords($scope).then(
                                function (sensitiveWords) {
                                    $scope.linkDocForm.$setPristine();
                                    $scope.list.ISCONTAINSENSITIVEWORDS = !!sensitiveWords.length ? 1 : 0;
                                    $scope.list.SENSITIVEWORDS = sensitiveWords;
                                    var list = dealDataBeforeSave();
                                    trsHttpService.httpServer('/wcm/mlfcenter.do', list, 'post').then(
                                        function (data) {
                                            dealDataAfterSave(data, flag);
                                            beforeonload.refresh($scope);
                                            deferred.resolve(data);
                                        },
                                        function (data) {
                                            $scope.status.openBtn = true;
                                            deferred.reject(data);
                                        }
                                    );
                                },
                                function () {
                                    $scope.status.isCheckSensitiveWords = Math.random();
                                    deferred.reject();
                                }
                            );
                        },
                        function () {
                            deferred.reject();
                        },
                        $scope.status.isFusionEditor
                    );
                })
                .error(function () {
                    editingCenterService.checkSaveError($scope.linkDocForm, $element, $scope); // 定位输入错的表单位置
                    deferred.reject();
                });
        }, 100);
        return deferred.promise;
    }

    /**
     * [examAttachFile description]检测attachFile字段,存在为空的字段删除
     * @return {[type]} [description]
     */
    function examAttachFile() {
        if ($scope.list.ATTACHFILE === '') {
            return;
        }
        angular.forEach($scope.files, function (value, key) {
            if (value.appFile === '') {
                $scope.list.ATTACHFILE.splice($scope.list.ATTACHFILE.indexOf(value), 1);
            }
        });
    }

    /**
     * [saveSend description]保存送审函数
     *
     * @return  {[type]}  [return description]
     */
    function saveSend() {
        newMediaService.trial($scope, websiteConst.trial).then((opinion) => {
            save().then(function () {
                $scope.params.METADATAID = $scope.list.METADATAID;
                $scope.params.CurrChnlId = $state.params.wzchannelid;
                $scope.params.opinion = opinion;
                let trialParams = angular.extend($scope.params, websiteConst.trial);
                messagePublishService.publish('doEditPageOperation', trialParams);
            });
        });

        // modalDialog.inputModel(
        //     '送审',
        //     '确定送审吗？',
        //     function(content) {
        //         $scope.params.Opinion = content;
        //         trsHttpService.httpServer('/wcm/mlfcenter.do', $scope.params, 'post', false).then(
        //             function(dataC) {
        //                 modalDialog.alertType(
        //                     '送审成功',
        //                     '',
        //                     'success',
        //                     false,
        //                     function() {
        //                         storageListenerService.addListenerToWebsite('send');
        //                         $window.close();
        //                     },
        //                     '',
        //                     1500
        //                 );
        //             },
        //             function() {
        //                 editIsLock.lockDraft($state.params.wzmetadataid);
        //             }
        //         );
        //     },
        //     '',
        //     function() {
        //         editIsLock.lockDraft($state.params.wzmetadataid);
        //     }
        // );
    }

    /**
     * [webSignPublish description]已签发平台保存并发布
     *
     * @return  {[type]}  [return description]
     */
    $scope.webSignPublish = function () {
        // save().then(function(data) {
        // $scope.params.serviceid = 'mlf_websiteoper';
        // $scope.params.methodname = 'webYiQianPublish';
        let params = {
            serviceid: 'mlf_websiteoper',
            methodname: 'webYiQianPublish'
        };
        singDirect(params, true);
        // });
    };

    /**
     * [singDirect description]直接签发函数
     * @param   {[type]}  params  [isSaveAndPublish description] 各个流程的签发接口名
     * @param   {[type]}  isSaveAndPublish  [isSaveAndPublish description]
     * @return  {[type]}                    [return description]
     */
    function singDirect(params, isSaveAndPublish) {
        var array = [$scope.list];
        if (isSaveAndPublish) {
            privateSign(params);
        } else {
            sensitiveWordCheckService.SensitiveWordsAndCareful(array, true, 2).then(
                function () {
                    privateSign(params);
                },
                function () {
                    privateSign(params);
                }
            );
        }

        /**
         * [privateSign description]签发
         * @param   {[type]}  params  [isSaveAndPublish description] 各个流程的签发接口名
         * @return  {[type]}  [return description]
         */
        function privateSign(params) {
            $scope.loadingPromise = newMediaService.sign($scope).then(function () {
                save().then(function (data) {
                    messagePublishService.publish('doEditPageOperation', angular.extend($scope.params, params));
                });
            });
        }
    }

    /**
     * [singTiming description]定时签发函数
     * @return  {[type]}  [return description]
     */
    function singTiming() {
        var methodname = ['webDaiBianTimingPublish', 'webDaiShenTimingPublish'];
        $scope.loadingPromise = newMediaService.timeSign($scope).then(function () {
            save().then(() => {
                let signParams = {
                    serviceid: 'mlf_websiteoper',
                    methodname: methodname[$state.params.wzplatform],
                    ObjectIds: $scope.list.CHNLDOCID,
                    ChnlDocIds: $scope.list.CHNLDOCID,
                    MetaDataIds: $scope.list.METADATAID,
                };
                messagePublishService.publish('doEditPageOperation', signParams);
            });
        });
    }

    /**
     * [rejection description]退稿函数
     *
     * @return  {[type]}  [return description]
     */
    function rejection() {
        newMediaService.rejection($scope, websiteConst.rejection).then((opinion) => {
            save().then(function () {
                $scope.params.Opinion = opinion;
                $scope.params.CHNLDOCIDS = $state.params.wzchnldocid;
                let KillParams = angular.extend($scope.params, websiteConst.rejection);
                messagePublishService.publish('doEditPageOperation', KillParams);
            });
        });
        // modalDialog.inputModel(
        //     '是否确认撤稿',
        //     '撤稿原因(可选)',
        //     function(content) {
        //         $scope.params.Opinion = content;
        //         trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get', false).then(
        //             function() {
        //                 modalDialog.alertType(
        //                     '撤稿成功',
        //                     '',
        //                     'success',
        //                     false,
        //                     function() {
        //                         storageListenerService.addListenerToWebsite('reject');
        //                         $window.close();
        //                     },
        //                     '',
        //                     1500
        //                 );
        //             },
        //             function() {
        //                 editIsLock.lockDraft($state.params.wzmetadataid);
        //             }
        //         );
        //     },
        //     '',
        //     function() {
        //         editIsLock.lockDraft($state.params.wzmetadataid);
        //     }
        // );
    }
    $scope.checkNetHead = function () {
        $scope.returnParams = editingCenterService.checkHasNetHead($scope.list.SRCURL);
        // eslint-disable-next-line no-unneeded-ternary
        $scope.status.showAddHeadTips = $scope.returnParams.hasHead === false ? true : false;
        $scope.list.SRCURL = $scope.returnParams.url;

    };
    $scope.goToPreviewLink = function () {
        window.open($scope.list.SRCURL);
    };

    /**
     * [preview description]保存预览
     *
     * @return  {[type]}  [return description]
     */
    function preview() {
        editingCenterService.draftPublish($state.params.wzchnldocid).then(
            function () { },
            function () {
                editIsLock.lockDraft($state.params.wzmetadataid);
            }
        );
    }

    /**
     * [doWithPicsOrAttach description]编辑中，初始化处理图片或者附件
     *
     * @param   {[type]}  array  [array description]
     *
     * @return  {[type]}         [return description]
     */
    function doWithPicsOrAttach(array) {
        // 处理READINGPICS字段为空数组的情况，防止相关图片框消失。
        if (array.length === 0) {
            array = [
                {
                    APPFILE: '',
                    APPDESC: '',
                },
            ];
        }
        return array;
    }

    /**
     * [close description]页面关闭
     * @return {[type]} [description]
     */
    $scope.close = function () {
        editingCenterService.closeWinow($scope.linkDocForm.$dirty, false).then(
            function () {
                save().then(function () {
                    storageListenerService.addListenerToWebsite('save');
                    editIsLock.normalLock($state.params.wzmetadataid).then(function (data) {
                        $window.close();
                    });
                });
            },
            function () {
                angular.isDefined($state.params.wzmetadataid)
                    ? editIsLock.normalLock($state.params.wzmetadataid).then(function (data) {
                        $window.close();
                    })
                    : $window.close();
            }
        );
    };

    /**
     * [initBtnArray description]初始化底部功能按钮
     *
     * @return  {[type]}  [return description]
     */
    function initBtnArray() {
        if ($scope.status.isawaitrevise) {
            // 待修订状态的编辑页只有保存按钮和修订按钮，在此处加入保存按钮
            addBtn();
            return;
        }
        // 所需权限初始化
        $scope.webSiteBtns = initWebsiteNewsService.initWebSitedBtns()[$state.params.wzplatform];
        // 查询权限方法
        $scope.methodArrary = ['web.daibian', 'web.daishen', 'web.yiqianfa'];
        initeditctrBtnsService.initWebsiteData($state.params.wzchannelid, $scope.methodArrary[$state.params.wzplatform]).then(function (data) {
            $scope.dictionaryBtn = [websiteBtnService.initWebCompBtn(), websiteBtnService.initWebPenBtn(), websiteBtnService.initSingBtn()];
            initeditctrBtnsService.initBtns(data, $scope.dictionaryBtn[$state.params.wzplatform]).then((btns) => {
                $scope.btnStatus = btns;
                $scope.arrayBtn = filterEditctrBtnsService.filterBtn($scope.btnStatus, $scope.webSiteBtns);
                addBtn();
            });
        });
        // 错别字校对按钮权限
        editcenterRightsService.initWebsiteListBtn('web.daishen', $state.params.wzchannelid).then(function (data) {
            $scope.status.hasHeimaRight = !!data['web.daishen.check'] ? 'true' : 'false';
        });
    }

    /**
     * [addBtn description]新增预览与关闭按钮
     *
     * @return  {[type]}  [return description]
     */
    function addBtn() {
        $scope.arrayBtn = $scope.arrayBtn ? $scope.arrayBtn : [];
        angular.forEach($scope.arrayBtn, function (data, index) {
            if (data.RIGHTINDEX == '496') {
                // 链接稿件去除二次审核
                $scope.arrayBtn.splice(index, 1);
            }
        });
        if ($state.params.wzplatform == 2) {
            return;
        }
        var OPERDESC = ['保存', '保存'];
        var OPERFUN = ['save', 'save'];
        $scope.arrayBtn.unshift({
            RIGHTINDEX: 'save',
            OPERDESC: OPERDESC[$state.params.wzplatform],
            OPERNAME: '',
            OPERFUN: OPERFUN[$state.params.wzplatform],
        });
        // $scope.arrayBtn.push({
        //     RIGHTINDEX: "close",
        //     OPERDESC: "关闭",
        //     OPERNAME: "",
        //     OPERFUN: "close"
        // });
    }

    /** ********************************************附件上传开始**********************************************/
    /**
     * [selectFiles description]选择文件
     * @param  {[type]} files    [description]所有文件
     * @param  {[type]} file     [description]
     * @param  {[type]} newFiles [description]新增的文件
     * @return {[type]}          [description]
     */
    $scope.selectFiles = function (files, file, newFiles) {
        $scope.status.isUploaderFile = true;
        angular.forEach(newFiles, function (value, key) {
            $scope.status.showFiles.push({
                SRCFILE: newFiles[key].name,
                APPDESC: newFiles[key].name,
                FILEINFO: '等待上传',
                FILE: newFiles[key],
            });
        });
        $scope.fileSubmit();
    };

    /**
     * [getAttachFile description]为ATTACHFILE重新复制，可更改
     * @return {[type]} [description]null
     */
    function saveAttachFile() {
        $scope.list.ATTACHFILE = [];
        angular.forEach($scope.status.showFiles, function (value, key) {
            if (value.FILEINFO === '上传成功') {
                delete value.FILE;
                delete value.progressPercentage;
                delete value.PICURL;
                delete value.PERPICURL;
                delete value.APPENDIXID;
                $scope.list.ATTACHFILE.push(value);
            }
        });
    }

    /**
     * [reWriteAttachFile description]上传
     *
     * @param   {[type]}  data  [data description]
     *
     * @return  {[type]}        [return description]
     */
    function reWriteAttachFile(data) {
        $scope.status.showFiles = angular.copy(data.ATTACHFILE);
        angular.forEach($scope.status.showFiles, function (value, key) {
            value.FILEINFO = '上传成功';
        });
    }

    /**
     * [clearAllKeywords description]清空关键词
     * @return {[type]} [description]
     */
    $scope.clearAllKeywords = function () {
        $scope.data.KEYWORDS = [];
    };

    /**
     * [fileSubmit description]附件提交
     * @return {[type]} [description]
     */
    $scope.fileSubmit = function () {
        if (angular.isUndefined($scope.linkDocForm.$error.filename)) {
            if ($scope.status.showFiles) {
                angular.forEach($scope.status.showFiles, function (file, key) {
                    if (file.FILEINFO === '等待上传') {
                        Upload.upload({
                            url: '/wcm/openapi/uploadImage',
                            data: {
                                file: file.FILE,
                            },
                        }).then(
                            function (resp) {
                                if (resp.data.success) {
                                    file.FILEINFO = '上传成功';
                                    file.APPFILE = resp.data.imgName;
                                    file.url = resp.data.imgSrc;
                                } else if (resp.data.error) {
                                    file.FILEINFO = '上传失败';
                                }
                            },
                            function (resp) { },
                            function (evt) {
                                // file.progressPercentage = parseInt(100.0 * evt.loaded / evt.total) + '%';
                                file.FILEINFO = '上传中';
                            }
                        );
                        $scope.status.isUploaderFile = false;
                    }
                });
            }
        } else {
            modalDialog.saveModel('附件上传失败', '附件填写有误', 'error', 'confirm');
        }
    };

    /**
     * [removeCurFile description]移除当前附件
     * @param  {[obj]} file  [description]被选中的附件
     * @param  {[num]} index [description]附件下标
     * @return {[type]}       [description]
     */
    $scope.removeCurFile = function (file, index) {
        $scope.status.showFiles.splice($scope.status.showFiles.indexOf(file), 1);
    };

    /** ********************************************附件上传结束*************************************************/

    /**
     * [webLinkCallback description]
     *
     * @param   {[type]}  params  [params description]
     *
     * @return  {[type]}          [return description]
     */
    function webLinkCallback(params) {
        var myImg = new Image();
        var sFileName = params.imageName || params.FN;
        var imageUrl = '/wcm/file/read_image.jsp?FileName=' + sFileName; // 文件没有保存之后，是U0开头

        if (sFileName.match(/^W0/)) {
            imageUrl = ['/webpic/', sFileName.substring(0, 8), '/', sFileName.substring(0, 10), '/', sFileName].join('');
            // imageUrl += "?r=" + new Date().getTime(); //添加水印之后，图片名称不变，防止图片不刷新
        }

        myImg.src = imageUrl;
        myImg.onload = function () {
            $scope.list.DOC_PICTURELIST[params.photoIndex].APPFILE = params.imageName;
            $scope.list.DOC_PICTURELIST[params.photoIndex].PERPICURL = imageUrl;
            delete $scope.list.DOC_PICTURELIST[params.photoIndex].APPENDIXID;
            editPhotoCallback();
        };
    }

    /**
     * [getSrcUrl description] 由稿件链接获取稿件页面
     * @return {[type]} [description]
     */
    $scope.getSrcUrl = function () {
        $scope.data.srcUrl = $sce.trustAsResourceUrl($scope.list.SRCURL);
    };

    $scope.getKeywordsOrAbstract = function (type) {
        var content = $scope.list.TITLE;
        if (content === '') {
            modalDialog.alertType('请先填写文章标题', '', 'warning', 'confirm');
            return;
        }
        editingCenterService.getKeywordsOrAbstract(type, $scope.list.TITLE).then(
            function (data) {
                if (type === 'keywords') {
                    if (data !== '""') {
                        var keywordsArray = data.substring(1, data.length - 1).split(';');
                        var arr = [];
                        angular.forEach(keywordsArray, function (value, key) {
                            arr.push({
                                name: value,
                            });
                        });
                        $scope.data.KEYWORDS = angular.isArray($scope.data.KEYWORDS) ? $scope.data.KEYWORDS : [];
                        $scope.data.KEYWORDS = $scope.data.KEYWORDS.concat(arr);
                        $scope.data.KEYWORDS = $filter('unique')($scope.data.KEYWORDS, 'name');
                        if ($scope.data.KEYWORDS.length > 10) {
                            $scope.data.KEYWORDS = $scope.data.KEYWORDS.splice(0, 10);
                        }
                    } else {
                        return;
                    }
                }
                if (type === 'abstract') {
                    $scope.list.ABSTRACT = data.substring(1, data.length - 1);
                }
            },
            function (data) { }
        );
    };
    $scope.invalidTag = function (tag) {
        var reg = /^[^<>\/;]*$/;
        if (tag.name.length > 20) {
            $scope.isShowKeywordTips = true;
            $scope.keywordsTips = '单个关键词长度不能超过20！';
        }
        if (!reg.test(tag.name)) {
            $scope.isShowKeywordTips = true;
            $scope.keywordsTips = '不能包含特殊字符！';
        }
    };
    $scope.checkTag = function (tag) {
        var len = $scope.data.KEYWORDS.length;
        if (len == 10) {
            $scope.isShowKeywordTips = true;
            $scope.keywordsTips = '关键词个数不能超过10个！';
            return false;
        } else {
            $scope.keywordsTips = '';
            $scope.isShowKeywordTips = false;
        }
        if (tag.name.indexOf(' ') > -1) {
            var spaceArr = tag.name.split(' ');
            $timeout(function () {
                $scope.data.KEYWORDS.pop();
                var containArr = [];
                for (var j = 0; j < $scope.data.KEYWORDS.length; j++) {
                    containArr.push($scope.data.KEYWORDS[j].name);
                }
                for (var i = 0; i < spaceArr.length; i++) {
                    if (containArr.indexOf(spaceArr[i]) < 0 && spaceArr[i] != '') {
                        $scope.data.KEYWORDS.push({
                            name: spaceArr[i],
                        });
                        containArr.push(spaceArr[i]);
                    }
                }
            });
        }
    };
    $scope.leave = function () {
        // $scope.isShowKeywordTips = false;
    };
    $scope.enter = function () {
        var reg = /^[^<>\/]*$/;
        if (angular.isDefined($scope.KEYWORDTEXT) && (!reg.test($scope.KEYWORDTEXT) || $scope.KEYWORDTEXT.length > 20)) {
            $scope.isShowKeywordTips = true;
        }
    };

    /**
     * [initKeyWords description]初始化关键词
     *
     * @return  {[type]}  [return description]
     */
    function initKeyWords() {
        if (angular.isDefined($scope.list.KEYWORDS) && $scope.list.KEYWORDS !== '') {
            var KEYWORDS = $scope.list.KEYWORDS.split(';');
            $scope.data.KEYWORDS = [];
            angular.forEach(KEYWORDS, function (data, index, array) {
                $scope.data.KEYWORDS.push({
                    name: data,
                });
            });
        } else {
            $scope.data.KEYWORDS = [];
        }
    }

    /**
     * [selectManuscript description]选择标签
     *
     * @param   {[type]}  item  [item description]
     * @param   {[type]}  type  [type description]
     *
     * @return  {[type]}        [return description]
     */
    $scope.selectManuscript = function (item, type) {
        if (type == 'tags') {
            if ($scope.data.selectTagArray.indexOf(item) < 0) {
                $scope.data.selectTagArray.push(item);
            } else {
                $scope.data.selectTagArray.splice($scope.data.selectTagArray.indexOf(item), 1);
            }
        }
    };

    /**
     * [selectAll description]相关新闻或标签全选
     *
     * @param   {[type]}  type  [type description]
     *
     * @return  {[type]}        [return description]
     */
    $scope.selectAll = function (type) {
        if (type == 'tags') {
            $scope.data.selectTagArray =
                $scope.data.selectTagArray.length == $scope.data.tag.selectTag.length ? [] : [].concat($scope.data.tag.selectTag);
        }
    };
    // 删除相关专题
    $scope.relNewsDelete = function (curIndex, type) {
        var selectIndex = $scope.data[type].indexOf(curIndex);
        var allIndex = $scope.data.tag.selectTag.indexOf(curIndex);
        $scope.data[type].splice(selectIndex, 1);
        $scope.data.tag.selectTag.splice(allIndex, 1);
    };

    /**
     * [manuscriptDelete description]删除相关新闻或标签
     *
     * @param   {[type]}  type  [type description]
     *
     * @return  {[type]}        [return description]
     */
    $scope.manuscriptDelete = function (type) {
        var index;
        if (type == 'tags') {
            for (var i = 0; i < $scope.data.selectTagArray.length; i++) {
                index = $scope.data.tag.selectTag.indexOf($scope.data.selectTagArray[i]);
                $scope.data.tag.selectTag.splice(index, 1);
            }
            $scope.data.selectTagArray.length = 0;
        }
    };

    /**
     * [moveDarft description]稿件移动
     *
     * @param   {[type]}  data_2  [data_2 description]
     *
     * @return  {[type]}          [return description]
     */
    function moveDarft(data_2) {
        if ($state.params.wzchnldocid) {
            var deferred = $q.defer();
            var params = {
                serviceid: 'mlf_websiteoper',
                methodname: $scope.data.moveMethodName[$state.params.wzplatform],
                SrcChannelId: $state.params.wzchannelid,
                ChnlDocIds: $state.params.wzchnldocid,
                ToChannelId: data_2[0].CHANNELID,
                moveMode: 1,
            };
            trsHttpService.httpServer('/wcm/mlfcenter.do', params, 'get').then(function (data) {
                if (data.ISSUCCESS === 'true') {
                    $scope.CHANNEL = data_2[0].CHANNELPATH;
                    $scope.list.CHANNELID = data_2[0].CHANNELID;
                } else {
                    $scope.status.isDarftMove = false;
                }
                storageListenerService.addListenerToWebsite('move');
            });
            deferred.resolve();
            return deferred.promise;
        } else {
            saveChannelInfo(data_2);
        }
    }

    /**
     * [saveChannelInfo description]保存稿件的栏目信息
     *
     * @param   {[type]}  data_2  [data_2 description]
     *
     * @return  {[type]}          [return description]
     */
    function saveChannelInfo(data_2) {
        $scope.CHANNEL = data_2[0].CHANNELPATH;
        $scope.list.CHANNELID = data_2[0].CHANNELID;
        template($scope.list.CHANNELID);
    }

    /**
     * [template description]配置模板
     *
     * @param   {[type]}  channelid  [channelid description]
     *
     * @return  {[type]}             [return description]
     */
    function template(channelid) {
        var deferred = $q.defer();
        var params = {
            serviceid: 'mlf_websiteconfig',
            methodname: 'getOptionalTemplates',
            ObjectType: '101',
            ObjectId: channelid,
            TEMPLATETYPE: '2',
            DocTemp: true,
        };
        $scope.loadingPromise = trsHttpService.httpServer('/wcm/mlfcenter.do', params, 'post').then(function (data) {
            var templateJson = data.DATA;
            var channel = [];
            channel.push({
                name: '请选择模板',
                value: 0,
            });
            for (var key in templateJson) {
                channel.push({
                    name: templateJson[key].TEMPNAME,
                    value: parseInt(templateJson[key].TEMPID),
                });
                if (templateJson[key].DEFAULTTEMP == 1 && !$state.params.wzchnldocid) {
                    $scope.list.TEMPNAME = {
                        name: templateJson[key].TEMPNAME,
                        value: templateJson[key].TEMPID,
                    };
                }
            }
            $scope.templateJson = channel;
            deferred.resolve($scope.templateJson);
        });
        return deferred.promise;
    }

    /**
     * [getKeyWords description]获取关键词
     *
     * @return  {[type]}  [return description]
     */
    function getKeyWords() {
        $scope.list.KEYWORDS = '';
        angular.forEach($scope.data.KEYWORDS, function (data, index, array) {
            if (index != $scope.data.KEYWORDS.length - 1) {
                $scope.list.KEYWORDS += data.name + ';';
            } else {
                $scope.list.KEYWORDS += data.name;
            }
        });
    }

    /**
     * [chooseTag description]选择标签
     * @return {[type]} [description]
     */
    $scope.chooseTag = function () {
        websiteService.subjectModel($state.params.wzmetadataid, $state.params.wzchannelid, $scope.data.tag.selectTag, function (result) {
            $scope.data.tag.hasChoose = true;
            $scope.data.tag.selectTag = result.selectedArray;
        });
    };

    /**
     * [chooseTag description]请求当前稿件的标签
     * @return {[type]} [description]
     */
    function getCurrDraftTag() {
        var params = {
            serviceid: 'mlf_tag',
            methodname: 'queryTagsFromViewData',
            metaDataId: $state.params.wzmetadataid,
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
            $scope.data.tag.selectTag = data;
        });
    }

    /**
     * [initTagAfterSave description]保存之后再次初始化标签需要的属性
     * @return {[type]} [description]
     */
    function initTagAfterSave() {
        $scope.data.tag.hasChoose = false;
    }

    /**
     * [chooseAscription description]选择稿件归属人
     *
     * @return  {[type]}  [return description]
     */
    $scope.chooseAscription = function () {
        websiteService.ascriptionModel($scope.data.ownerSelectedItems, function (result) {
            $scope.data.ownerSelectedItems = result.selectedArray;
        });
    };

    /**
     * [deleteAscription description] 删除稿件归属人
     * @param  {[type]} index [description] 序列
     * @return {[type]}       [description]
     */
    $scope.deleteAscription = function (index) {
        $scope.data.ownerSelectedItems.splice(index, 1);
    };

    /* 融合编辑器额外功能开始*/
    if ($scope.status.isFusionEditor) {

        /**
         * [pageCantEdit description] 已提交渠道编辑页不能编辑
         * @param  {[type]} type [description] 稿件信息或属性信息
         * @return {[type]}      [description]
         */
        $scope.pageCantEdit = function (type) {
            $timeout(function () {
                if (type == 'manuscriptInfo') {
                    var manuHeight = $('.website_manuscript_info').height();
                    var manuWidth = $('.website_manuscript_info').width();
                    $('.pageCantEdit')
                        .find('.cantEditPart')
                        .height(manuHeight)
                        .width(manuWidth);
                    $('.website_manuscript_info').resize(function () {
                        $('.pageCantEdit')
                            .find('.cantEditPart')
                            .height($(this).height());
                    });
                } else if (type === 'attrInfo') {
                    var attrHeight = $('.website_attr_info').height();
                    var attrWidth = $('.website_attr_info').width();
                    $('.pageCantEdit')
                        .find('.cantEditPart')
                        .height(attrHeight)
                        .width(attrWidth);
                    $('.website_attr_info').resize(function () {
                        $('.pageCantEdit')
                            .find('.cantEditPart')
                            .height($(this).height());
                    });
                }
            }, 300);
        };

        /**
         * [initData description] 融合编辑器切换渠道时的初始化数据
         * @param {[type]} [dealWithListFun] [description] 融合编辑器下处理list的方法
         * @return {[type]} [description]
         */
        $scope.initData = function (dealWithListFun) {
            var defer = $q.defer();
            if (angular.isDefined($state.params.wzchnldocid)) {
                initEditDraftData(dealWithListFun).then(function () {
                    defer.resolve();
                });
            } else {
                initNewDraftData(dealWithListFun);
                defer.resolve();
            }
            return defer.promise;
        };

        /**
         * [loadFgd description] 加载发稿单
         * @return {[type]} [description]
         */
        $scope.loadFgd = function () {
            var draftList =
                '<editor-dir list="list" meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="linkDocForm"></editor-dir>' +
                '<editor-auth-dir originalchildtype="list.ORIGINAL==1&&data.originType==3?1:0" author="list.FGD_AUTHINFO"></editor-auth-dir>';
            draftList = $compile(draftList)($scope);
            $element.find('editor').append(draftList);
        };
    }

    /* 融合编辑器额外功能结束*/
}
